import { ErrorAlert as ErrorAlertBase } from '@otuvy/ionic-react-common';
import { atom, useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

/**
 * Set to `true` for the default error message, or set to an i18n key to display
 * a custom message. Set to `false` to hide the alert.
 */
export const errorAlertMessageKeyState = atom<string | boolean>({
  key: 'errorAlertMessageKeyState',
  default: false,
});

const ErrorAlert: React.FC = () => {
  const { t } = useTranslation();
  const [messageKey, setMessageKey] = useRecoilState(errorAlertMessageKeyState);

  return <ErrorAlertBase t={t} messageKey={messageKey} setMessageKey={setMessageKey} />;
};

export default ErrorAlert;
